import request from '@/utils/request'


export function login(data) {
    return request({
        url: `/customer-service/login`,
        method: 'post',
        data: data
    })
}

export function logout() {
    return request({
        url: `/customer-service/logout`,
        method: 'post'
    })
}

// const convertMenus = function (menuButtons) {
//     var menus = [];
//     var buttons = {};
//     menuButtons.forEach(function (item, index) {
//         var menu = item;
//         var button = item;
//         if (item.children) {
//             var result = convertMenus(item.children);
//             menu.children = result.menus || [];
//             buttons = {...buttons, ...result.buttons};
//         }
//         // 0目录、1菜单、2跳转按钮、3提交按钮
//         if (item.type !== 3) {
//             menus.push(menu);
//         }
//         if (item.type === 2 || item.type === 3) {
//             button.children = null;
//             buttons[button.id] = button;
//         }
//     });
//     return {
//         menus,
//         buttons
//     };
// };
// export {
//     convertMenus
// }